module.exports = __webpack_public_path__ + "img/Skoda_Wordmark_RGB_Emerald_Green.ba4d674b.png";